import type { FC } from 'react'
import { useState } from 'react'

import VerifyButton from '@/components/VerifyButton'
import type { AdverseCredit } from '@/types/adverseCredit'

import VerifyCreditSidebar from './Sidebar'

interface Props {
  customerId: string
  subjectId: string
  identityConfirmed: boolean
  residencyConfirmed: boolean
  adverseCredit: AdverseCredit[]
  disabled?: boolean
}

const VerifyCredit: FC<Props> = ({
  customerId,
  subjectId,
  identityConfirmed,
  residencyConfirmed,
  adverseCredit,
  disabled,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <VerifyCreditSidebar
          customerId={customerId}
          subjectId={subjectId}
          identityConfirmed={identityConfirmed}
          residencyConfirmed={residencyConfirmed}
          adverseCredit={adverseCredit}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <VerifyButton onClick={() => setIsSidebarOpen(true)} disabled={disabled} />
    </>
  )
}

export default VerifyCredit
